"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import LoadTable from "./load_table";
import LoadSearchForm from "./load_search_form";
import CarrierName from "../carrier_name";
function maybeShowAllCarrierNotification(props, state) {
  if (state.fell_back_to_any_carrier) {
    return /* @__PURE__ */ jsxs("div", { className: "alert-box--highlight", children: [
      "No matches found for ",
      /* @__PURE__ */ jsx(CarrierName, { carrierID: props.carrier.id }),
      ", searching all ",
      Account.carrierTermLower(),
      "s."
    ] });
  }
}
function loadTable(props, state) {
  if (!_.isEmpty(state.loads) || state.searched) {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__search-results", children: [
      maybeShowAllCarrierNotification(props, state),
      /* @__PURE__ */ jsx("h3", { children: "Search Results" }),
      /* @__PURE__ */ jsx(
        LoadTable,
        {
          items: state.loads,
          loadsNotFromEmailCarrier: props.loadsNotFromEmailCarrier,
          selectedLoadStateId: props.selectedLoadStateId,
          highlightedLoads: props.highlightedLoads,
          onSelectionChange: props.onSelectionChange,
          highlightChanged: props.highlightReference
        }
      )
    ] });
  }
}
function possibleLoadMessage(props) {
  var message;
  if (props.multiCarrier) {
    message = `We couldn't find any loads in this document. First, use the search below to look for loads or click "Create an exception" below to report a problem. Next, assign a ` + Account.carrierTermLower() + ".";
  } else {
    message = `We couldn't find any loads in this document. Use the search below to look for loads or click "Create an exception" below to report a problem.`;
  }
  if (props.highlightedLoads.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "alert-box--progress", children: message });
  }
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { loads: [], searched: false });
    __publicField(this, "onSearch", (terms) => {
      this.setState({ searching: true });
      this.props.searcher(terms).then((data) => {
        this.setState({
          searching: false,
          loads: data.loads,
          fell_back_to_any_carrier: data.fell_back_to_any_carrier,
          searched: true
        });
      });
    });
    __publicField(this, "onCancel", () => {
      this.setState({ searching: false, loads: [] });
      this.props.onCancel();
    });
  }
  render() {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__search-area", children: [
      possibleLoadMessage(this.props),
      /* @__PURE__ */ jsx("p", { className: "load-assigner__search-instructions", children: "Search for loads to assign." }),
      /* @__PURE__ */ jsx(
        LoadSearchForm,
        {
          carrier: this.props.carrier,
          searching: this.state.searching,
          onSearch: this.onSearch,
          onCancel: this.onCancel
        }
      ),
      loadTable(this.props, this.state)
    ] });
  }
}
